import { useTranslation } from "react-i18next";
import { Button, Col, Drawer, Form, Row, Spin, Typography } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import FormItemInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import "./form-create-question-bank.scss";
import { globalStore } from "../../../../../stores/stores";
import { GlobalOutlined, LockOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { getAllIndustryGroup } from "../../../../../service/course-construct";
import { FormInstance } from "antd/lib";
import TextArea from "antd/es/input/TextArea";

type FormCreateQuestionBankProps = {
  open: boolean;
  form: FormInstance;
  isOpenEdit?: boolean;
  isLoadingForm?: boolean;
  detailDataQuestionBank?: any;
  onClose: () => void;
  onFinishCreate: (value: any) => void;
  setIsLoadingForm: (value: boolean) => void;
};

const FormCreateQuestionBank = ({
  open,
  form,
  isOpenEdit,
  isLoadingForm,
  detailDataQuestionBank,
  onClose,
  onFinishCreate,
  setIsLoadingForm,
}: FormCreateQuestionBankProps) => {
  const { t } = useTranslation();
  const [industryGroupOptions, setIndustryGroupOptions] = useState<any>([]);

  const validations = {
    name: {
      required: true,
      validator: (_: unknown, value: string) => {
        if (value && value.length < 3) {
          return Promise.reject(
            new Error("Tên ngân hàng phải từ 3 ký tự trở lên")
          );
        }
        if (!value) {
          return Promise.reject(new Error("Vui lòng nhập tên khóa học"));
        }
        return Promise.resolve();
      },
    },
  };

  const getIndustryGroup = async () => {
    setIsLoadingForm(true);
    try {
      const res = await getAllIndustryGroup();
      if (res.status === 200) {
        setIndustryGroupOptions(res.data?.data);
        setIsLoadingForm(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingForm(false);
    }
  };

  useEffect(() => {
    if (detailDataQuestionBank && isOpenEdit) {
      form.setFieldsValue({
        name: detailDataQuestionBank.title,
        description: detailDataQuestionBank?.description,
        faculty: detailDataQuestionBank?.industries,
      });
    }
  }, [detailDataQuestionBank]);

  useEffect(() => {
    if (open) {
      getIndustryGroup();
    }
  }, [open]);

  return (
    <Drawer
      title={isOpenEdit ? t("Chỉnh sửa ngân hàng câu hỏi", "Chỉnh sửa ngân hàng câu hỏi") : t("Thêm mới ngân hàng câu hỏi", "Thêm mới ngân hàng câu hỏi")}
      open={open}
      onClose={!isLoadingForm ? onClose : undefined}
      width={736}
      maskClosable={false}
      extra={
        <Button className="btn btn-primary" disabled={isLoadingForm} onClick={() => form.submit()}>
          {t("Lưu", "Lưu")}
        </Button>
      }
      className="create-question-bank-drawer"
    >
      {isLoadingForm ? (
        <Spin size="large" />
      ) : (
        <Form
          className="form-create-question-bank"
          form={form}
          onFinish={() => onFinishCreate(form.getFieldsValue())}
          layout="vertical"
          initialValues={{
            permissionPreview: "2",
            generalAccess: "1",
            generalPermission: "2",
          }}
        >
          <Row gutter={8} className="question-bank-row info-block">
            <Col span={24} className="question-bank-title">
              <Typography.Title level={5}>{t("Thông tin", "Thông tin")}</Typography.Title>
            </Col>

            <Col span={24} className="question-bank-col">
              <Form.Item
                className="question-bank-info"
                name="name"
                label={t("Tên ngân hàng", "Tên ngân hàng")}
                rules={[validations.name]}
              >
                <FormItemInput placeholder={t("Nhập tên ngân hàng", "Nhập tên ngân hàng")} />
              </Form.Item>
            </Col>
            <Col span={24} className="question-bank-col">
              <Form.Item
                className="question-bank-info"
                label={t("Mô tả", "Mô tả")}
                name="description"
              >
                <TextArea rows={3} showCount maxLength={200} placeholder={t("Nhập mô tả", "Nhập mô tả")} />
              </Form.Item>
            </Col>
            <Col span={24} className="question-bank-col">
              <Form.Item
                className="question-bank-info"
                label={t("Khoa", "Khoa")}
                name="faculty"
              >
                <FormItemDropdown
                  placeholder={t("Chọn khoa", "Chọn khoa")}
                  options={industryGroupOptions}
                  modeDropdown="multiple"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Drawer>
  );
};

export default FormCreateQuestionBank;
